import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Settings = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M14.5 7.905h-10m10 0a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 1 1-6.5 0m6.5 10h-8m0 0a3.25 3.25 0 1 1-6.5 0m6.5 0a3.25 3.25 0 1 0-6.5 0m0 0h-2'
      />
    ) : (
      <>
        <path
          d='M9 13a4 4 0 0 0-3.93 3.25H3.75a.75.75 0 0 0 0 1.5h1.32a4 4 0 0 0 7.86 0h7.32a.75.75 0 0 0 0-1.5h-7.32A4 4 0 0 0 9 13'
          fill='currentColor'
        />
        <path
          d='M15 11a4 4 0 0 0 3.93-3.25h1.32a.75.75 0 0 0 0-1.5h-1.32a4 4 0 0 0-7.86 0H3.75a.75.75 0 0 0 0 1.5h7.32A4 4 0 0 0 15 11'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
